import React from 'react'
import { TableHead, TableRow, TableCell } from 'transfix-ui'

export const LaneAlertsTableHeaders = () => (
  <TableHead>
    <TableRow>
      <TableCell>Lane Preference</TableCell>
      <TableCell>Pickup Availability</TableCell>
      <TableCell>Recipient</TableCell>
      <TableCell>Created By</TableCell>
      <TableCell> </TableCell>
    </TableRow>
  </TableHead>
)
